
import * as api from "../../api"; 

  
export const userSignup = (post) => async (dispatch)=>{
    try {
        const {data } = await api.userSignup(post);
            // console.log(data)
        
           dispatch({
            type: "SIGNUP",
            /* In my Case , I am getting data in the form of JSON encode String so , I am covverting it into 
            Object Before storing it into Redux store using () */ 
            payload:(data?.userData)
          }); 


          dispatch({
            type: "APPDATA",
            
            payload:data?.apps
          });
          
         /* return data in the form of a Promise to the function where it was called  */
         let MyToken =(data?.userData)?.token;
         localStorage.setItem("profile",MyToken)
      
        return (data)?.userData 
     } catch (error) {
        console.error(error);
    }
}


export const userResetPassword = (post) => async (dispatch)=>{
    try {
        const {data } = await api.userResetPassword(post);
        dispatch({
            type: "CurrentUserEmail",
            /* In my Case , I am getting data in the form of JSON encode String so , I am covverting it into 
            Object Before storing it into Redux store using () */ 
            payload:post
          }); 
         /* return data in the form of a Promise to the function where it was called  */
     
        return (data)?.userData ;
    } catch (error) {
        console.log(error);
    }
}

export const userAddNewPassword = (post) => async (dispatch)=>{
    try {
        const {data } = await api.userAddNewPassword(post);
        
         /* return data in the form of a Promise to the function where it was called  */
      
        return data?.userData ;
    } catch (error) {
        console.log(error);
    }
}

export const userVerifyOTP = (post) => async (dispatch)=>{
    try {
        const {data } = await api.userVerifyOTP(post);
       
       if((data)?.userData?.token){


        dispatch({
            type: "UPDATE_USER_DATA",
            
            /* In my Case , I am getting data in the form of JSON encode String so , I am covverting it into 
            Object Before storing it into Redux store using () */ 
            payload:(data)?.userData
          }); 

          dispatch({
            type: "APPDATA",
            
            payload:data?.apps
          });
       }
         /* return data in the form of a Promise to the function where it was called  */
         
         let MyToken =(data)?.userData?.token;
         localStorage.setItem("profile",MyToken)
      
        return (data)?.userData ;
    
        } catch (error) {
        console.log(error);
    }
}

export const userLogin = (post) => async (dispatch)=>{
    try {
        const {data } = await api.userLogin(post);
        // console.log(data)
         dispatch({
            type: "LOGIN",
            
            /* In my Case , I am getting data in the form of JSON encode String so , I am covverting it into 
            Object Before storing it into Redux store using () */ 
            payload:(data?.userData)
          }); 
          dispatch({
            type: "APPDATA",
            
            payload:data?.apps
          });
          let MyToken =(data)?.userData?.token;
          localStorage.setItem("profile",MyToken)
         /* return data in the form of a Promise to the function where it was called  */
     
        return (data?.userData) ;
    } catch (error) {
        return(error.response.data.message);
    }
}





